import React from 'react';
import { useNavigate } from 'react-router-dom';
import Reactoons from '../components/games/Reactoons';
import { useStore } from '../store/useStore';
import './ReactoonsPage.css';

const ReactoonsPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, updateBalance } = useStore();

  const handleBalanceChange = (newBalance: number) => {
    updateBalance(newBalance);
  };

  return (
    <div className="reactoons-page">
      {/* Кнопка назад */}
      <button className="back-button" onClick={() => navigate(-1)}>
        <span>←</span> Назад
      </button>

      {/* Игра */}
      <Reactoons
        balance={user?.balance || 1000}
        onBalanceChange={handleBalanceChange}
      />
    </div>
  );
};

export default ReactoonsPage;
